export default __webpack_public_path__ + "static/media/6.294d7de1.png";